<template>
  <editor class="editor" @changeContent = "changeContent" ref="myTextEditor" v-model="editorContent"></editor>
</template>

<style lang="scss">
.text-editor-image-box {
  position: relative;
  top: 5px;
}

.ql-editor {
  .ql-size-small {
    font-size: 10px !important;
  }

  .ql-size-large {
    font-size: 14px !important;
  }

  .ql-size-huge {
    font-size: 18px !important;
  }
}
</style>

<script>
import editor from './TmsTextEditorNew.vue';
export default {
  props: {
    content: {
      type: String,
    },
  },
  components: {
    editor
  },
  data() {
    return {
      editorContent: this.content,
    };
  },
  watch: {
    content: function(val) {
      this.editorContent = val;
    },
    editorContent: function(val) {
      this.$emit("contentUpdated", val);
    },
  },
  methods: {
    changeContent(val){
      this.editorContent = val;
    },
  },
};
</script>
